import lazyImport from '../../../Utils/Loading/loadingHelpers'

export const Accordion = lazyImport(() => import('@mui/material/Accordion'))
export const AccordionDetails = lazyImport(() => import('@mui/material/AccordionDetails'))
export const AccordionSummary = lazyImport(() => import('@mui/material/AccordionSummary'))